
import { createClient } from '@supabase/supabase-js';

export const supabaseUrl = 'https://iqeqgeymhmoeugfbsxos.supabase.co';
export const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlxZXFnZXltaG1vZXVnZmJzeG9zIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzAzODQyMjYsImV4cCI6MjA4NTk2MDIyNn0.uIUWLCJPO-YJ_NMx992zR-4taHE1XEi5QgpobPTBeTg';

// 1. Debug: Log URL to verify environment variable in production
if (import.meta.env.PROD) {
  console.log("[Supabase] Initializing client with fixed URL:", supabaseUrl.substring(0, 15) + '...');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    storageKey: 'sb-auth-token',
  }
});


